import { Suspense } from 'react';
import { Provider } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider, StyleSheetManager } from 'styled-components';
// mui
import Box from '@mui/material/Box';
import { createTheme, ThemeProvider as MaterialThemeProvider } from '@mui/material/styles';
// features
import Loader from './features/loader';
// root
import store from './store';
import CustomRoutes from './router/custom-routes';
// utilities
import './utilities/translations';
import { theme, shouldForwardProp } from './utilities';
////////////////////////////////////////////////

const App = () => {
  const materialTheme = createTheme(theme);

  return (
    <Provider store={store}>
      <MaterialThemeProvider theme={materialTheme}>
        <ThemeProvider theme={theme}>
          <Suspense fallback={<Box width='100vw' height='100vh' backgroundColor='background.page' />}>
            <ToastContainer style={{ width: 'max-content' }} />
            <BrowserRouter>
              <StyleSheetManager shouldForwardProp={shouldForwardProp}>
                <CustomRoutes dispatch={store.dispatch} />
                <Loader />
              </StyleSheetManager>
            </BrowserRouter>
          </Suspense>
        </ThemeProvider>
      </MaterialThemeProvider>
    </Provider>
  );
};

export default App;
